// extracted by mini-css-extract-plugin
export default {"sectionOneCol1":"styles_sectionOneCol1__feivW","sectionOneCol2":"styles_sectionOneCol2__4PVQ7","sectionOneCol2Img":"styles_sectionOneCol2Img__j6FiT"};